import { NavLink } from 'react-router-dom';

const BROWSE_TILES = [
  { to: '/audiobooks', label: 'Audiobooks' },
  { to: '/music',      label: 'Music' },
  { to: '/movies',     label: 'Movies' },
  { to: '/videos',     label: 'Videos' },
  { to: '/photos',     label: 'Photos' },
];

export default function Home() {
  return (
    <div className="FV-home">
      <section>
        <h2 className="FV-row-title">Continue Listening</h2>
        <p className="FV-empty">No items yet.</p>
      </section>
      <section>
        <h2 className="FV-row-title">Continue Watching</h2>
        <p className="FV-empty">No items yet.</p>
      </section>
      <section>
        <h2 className="FV-row-title">Recently Added</h2>
        <p className="FV-empty">No items yet.</p>
      </section>
      <section>
        <h2 className="FV-row-title">Browse</h2>
        <div className="FV-browse-tiles">
          {BROWSE_TILES.map(tile => (
            <NavLink key={tile.to} to={tile.to} className="FV-browse-tile">
              {tile.label}
            </NavLink>
          ))}
        </div>
      </section>
    </div>
  );
}
